import { createReducer } from 'typesafe-actions';
import { CompareActions, UserActionState } from '../types';
import {
  PRODUCTS_COMPARE_MANAGE,
  SEND_PRODUCTS_COMPARE_ACTION,
  AllProductsCompareActions,
  SendProductsCompareAction,
  RetryLastCompareAction,
  ManageProductInCompareListAction,
  RESET_PRODUCTS_COMPARE_ACTION,
} from '../actions';
import { INITIAL_USER_ACTION_STATE } from './constants';

export const userAction = createReducer<
  UserActionState,
  | SendProductsCompareAction
  | AllProductsCompareActions
  | RetryLastCompareAction
  | ManageProductInCompareListAction
>(INITIAL_USER_ACTION_STATE)
  .handleAction(PRODUCTS_COMPARE_MANAGE.request, (state, { payload }) => ({
    ...INITIAL_USER_ACTION_STATE,
    action: CompareActions.REQUEST,
    groupId: payload.groupId,
    productId: payload.productId || '',
  }))
  .handleAction(SEND_PRODUCTS_COMPARE_ACTION, (_, { payload }) => ({
    ...payload,
  }))
  .handleAction(RESET_PRODUCTS_COMPARE_ACTION, () => ({
    ...INITIAL_USER_ACTION_STATE,
    action: null,
  }));
